import { loadElasticSearchResults } from '@modules/product-tagging/api/load-elastic-search-results.server';
import type { LoaderFunctionArgs } from '@remix-run/node';

export const ProductTaggingProductSearch =
    '/remix-api/product-tagging/product-search';

export const loader = async ({ context, request }: LoaderFunctionArgs) => {
    return await loadElasticSearchResults({
        context,
        request,
        searchType: 'product',
    });
};
